import { DropDown, SearchBar, NewSiteButton } from "../components/textField";
import TopNav from "../components/topnav";
import EnhancedTable from "../components/newTable";
import { useState, useEffect, useMemo } from "react";
import Edit from "../assests/edit.png";
import { content } from "../utils/data";
import {
  createNewCase,
  editCourtCase,
  getCourtCases,
  getUniqueNo,
  getCourtStatus,
  getOsNumber,
  getCaseTypes,
  getCourtStage,
} from "../api/serverApi";
import { Link, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { CourtForm, EditCourtCase } from "../components/dropdowns";
import SiteModal from "../components/siteCreationModal";
import Spinner from "../components/spinner";
import { Autocomplete, TextField, Button } from "@mui/material";
import { useCookies } from "react-cookie";
import StatusModal from "../components/statusModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";
import CourtHistoryModal from "../components/courtHistory";
import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import * as microsoftTeams from "@microsoft/teams-js";
import TruncatedText from "../components/truncatedText";

const CourtCases = () => {
  const navigate = useNavigate();
  const [filteredRows, setFilteredRows] = useState([]);
  const [summary, setSummary] = useState("");
  const [originalSuite, setOriginalSuite] = useState("");
  const [litigationAcre, setLitigationAcre] = useState("");
  const [litigationGunta, setLitigationGunta] = useState("");
  const [foundationRole, setFoundationRole] = useState(""); // <-- this should store ID
  const [foundationRoleName, setFoundationRoleName] = useState(""); // optional
  const [plaintiff, setPlaintiff] = useState("");
  const [defendant, setDefendant] = useState("");
  const [impleader, setImpleader] = useState("");
  const [respondent, setRespondent] = useState("");
  const [intervenor, setIntervenor] = useState("");
  const [appellant, setAppellant] = useState("");
  const [uniqueNo, setUniqueNo] = useState([]);
  const [selectedUnique, setSelectedUnique] = useState([]);
  const [NextHearingDate, setNextHearingDate] = useState(null);
  const [closureDate, setClosureDate] = useState(null);
  const [osDate, setOsDate] = useState("");
  const [open, setOpen] = useState(false);
  const [site, setSite] = useState("");
  const [originalDate, setOriginalDate] = useState("");
  const [surevyNo, setSurveyNo] = useState("");
  const [suiteNo, setSuiteNo] = useState("");
  const [oldSuiteNo, setOldSuiteNo] = useState("");
  const [hearingDate, setHearingDate] = useState(null);
  const [status, setStatus] = useState("");
  const [newSummary, setNewSummary] = useState("");
  const [date, setDate] = useState(null);
  const [courtCase, setCourtCase] = useState([]);
  const [stateName, setStateName] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [currentEditSite, setCurrentEditSite] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const [loading, setLoading] = useState(false);
  const [osNo, setOsNo] = useState([]);
  const [osNoId, setOsNoId] = useState("");
  const [uniqueSurveyNo, setUniqueSurveyNo] = useState([]);
  const [selectedUniqueId, setSelectedUniqueId] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [selectedOsNumber, setSelectedOsNumber] = useState(null);
  const { instance, accounts } = useMsal();
  const [modalSource, setModalSource] = useState(null);
  const [caseTypes, setCaseTypes] = useState([]);
  const [selectedCaseType, setSelectedCaseType] = useState("");

  const [courtCaseDetails, setCourtCaseDetails] = useState("");
  const [lastDate, setLastDate] = useState(null);
  const [advocateName, setAdvocateName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [caseRequirement, setCaseRequirement] = useState("");
  const [cnrNumber, setCnrNumber] = useState("");
  const [courtStages, setCourtStages] = useState([]);
  const [selectedCourtStage, setSelectedCourtStage] = useState("");

  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);
  const { siteId, siteName, state, locationName, siteType } =
    location.state || {};

  const responseData = [
    {
      site_id: siteId,
      name: siteName,
      state: state,
      location_name: locationName,
    },
  ];
  const [isEditing, setIsEditing] = useState(false);


const handleOpen = () => {
  // Reset all Add Court Case fields
  resetSurveyForm();

  // Make sure this is Add mode, not Edit mode
  setIsEditing(false);

  // Clear edit-related state
  setCurrentEditSite(null);
  setOldSuiteNo("");
  setSelectedCaseType("");

   setOpen(true); // Open the modal for site creation
    setSite(""); // Optionally reset state-related fields
};





  const handleClose = () => setOpen(false);
  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };
  // requirement want to disbale survey no and Area In Acre for other site type
  //  so using useMemo to render different table header based on site type
  // "content.courtLitigation;"" is a orginal table header
  const tableHeaders = useMemo(() => {
    if (siteType?.toLowerCase() === "others") {
      return content.courtLitigation.filter(
        (col) =>
          col.id !== "unique_survey_no" &&
          col.id !== "area_under_litigation_gunta" &&
          col.id !== "area_under_litigation_acre",
      );
    }
    return content.courtLitigation;
  }, [siteType]);

  // ends here
  useEffect(() => {
    const fetchCourtCases = async () => {
      if (!siteId) return;
      setLoading(true);
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const res = await getCourtCases(siteId, token);
        setFilteredRows(Array.isArray(res.data.sites) ? res.data.sites : []);
      } catch (err) {
        const message =
          err.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    };
    fetchCourtCases();
  }, [siteId, instance, accounts]);

  useEffect(() => {
    if (siteId) {
      getOsNumber(siteId)
        .then((response) => {
          setOsNo(response.data);
        })
        .catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          // setLoading(false);
        });
    } else {
    }
  }, [siteId]);

  useEffect(() => {
    if (siteId) {
      getCaseTypes(siteId)
        .then((res) => {


          setCaseTypes(res.data);
        })
        .catch((err) => {});
    }
  }, [siteId]);
  useEffect(() => {
    const fetchCourtStages = async () => {
      try {
        const response = await getCourtStage();
        setCourtStages(response.data);
      } catch (error) {
        console.error("Error fetching court stages:", error);
      }
    };

    fetchCourtStages();
  }, []);
  const openModalWithOs = (os_number) => {
    setSelectedOsNumber(os_number);
    setOpenHistoryModal(true);
  };

  const rowsWithActions = useMemo(() => {
    return (filteredRows || []).map((row) => {
      const {
        os_number,
        os_date,
        summary,
        next_hearing_date,
        closure_date,
        unique_survey_no,
        case_type_id, // 👈 IMPORTANT
        ...rest
      } = row;

      return {
        os_number,
        case_type: row.case_type || "", // ✅ direct use

        summary: <TruncatedText text={summary} maxLines={2} />,

        os_date: os_date ? dayjs(os_date).format("DD-MM-YYYY") : "",

        unique_survey_no: Array.isArray(unique_survey_no)
          ? unique_survey_no.join(", ")
          : "",

        ...rest,

        next_hearing_date: next_hearing_date
          ? dayjs(next_hearing_date).format("DD-MM-YYYY")
          : "",

        closure_date: closure_date
          ? dayjs(closure_date).format("DD-MM-YYYY")
          : "",

        actions: (
          <div className="flex">
            <img
              src={Edit}
              alt="Edit"
              style={{
                width: "20px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={() => handleEdit(os_number)}
            />

            <Button
              size="small"
              title="Court Case History"
              style={{
                borderRadius: "50%",
                minWidth: "32px",
                width: "32px",
                height: "32px",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => openModalWithOs(os_number)}
            >
              <InfoOutlinedIcon fontSize="small" style={{ margin: 0 }} />
            </Button>
          </div>
        ),
      };
    });
  }, [filteredRows, caseTypes]); // 👈 IMPORTANT dependency

  const rowsFiltered = useMemo(() => {
    const normalizedSearch = searchText
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    let filtered = rowsWithActions;

    // Filter by unique_survey_no
    if (selectedUniqueId && selectedUniqueId.length > 0) {
      const selectedUniqueNos = selectedUniqueId.map((item) =>
        String(item.unique_survey_no),
      );
      filtered = filtered.filter((row) =>
        selectedUniqueNos.includes(String(row.unique_survey_no)),
      );
    }
    // Filter by os_number
    if (osNoId && osNoId !== "") {
      filtered = filtered.filter(
        (row) => String(row.os_number) === String(osNoId),
      );
    }

    // Search filter across multiple fields
    if (normalizedSearch) {
      filtered = filtered.filter((row) => {
        const content = [
          row.case_type, // ✅ include case type in search
          row.os_number,
          row.summary,

      // Search by CNR Number
      row.cnr_number,

      // Search by Court Stage
      row.stage,
          row.unique_survey_no,
          row.next_hearing_date
            ? dayjs(row.next_hearing_date).format("DD-MM-YYYY")
            : "",
          row.closure_date ? dayjs(row.closure_date).format("DD-MM-YYYY") : "",
          row.status,
        ]
          .map((val) =>
            String(val || "")
              .replace(/\s+/g, " ")
              .toLowerCase(),
          )
          .join(" ");
        return content.includes(normalizedSearch);
      });
    }
    return filtered;
  }, [rowsWithActions, selectedUniqueId, osNoId, searchText]);

  const handleCnrNumber = (event) => {
    setCnrNumber(event.target.value);
  };
  const handleCourtCaseDetails = (event) => {
    setCourtCaseDetails(event.target.value);
  };

  const handleLastDate = (event) => {
    setLastDate(event.target.value);
  };

  const handleAdvocateName = (event) => {
    setAdvocateName(event.target.value);
  };

  const handleContactNumber = (event) => {
    setContactNumber(event.target.value);
  };

  const handleCaseRequirement = (event) => {
    setCaseRequirement(event.target.value);
  };

  const handleSummary = (event) => {
    setSummary(event.target.value); // Captures text field input
  };
  const handleOriginalSuite = (event) => {
    setOriginalSuite(event.target.value); // Captures text field input
  };
  const handleLitigationAcre = (event) => {
    setLitigationAcre(event.target.value); // Captures text field input
  };
  const handleLitigationGunta = (event) => {
    setLitigationGunta(event.target.value); // Captures text field input
  };
  const handleFoundationRole = (id, roleName) => {
    setFoundationRole(id);
    setFoundationRoleName(roleName);
  };
  const handlePlaintiff = (event) => {
    setPlaintiff(event.target.value); // Captures text field input
  };
  const handleDefendant = (event) => {
    setDefendant(event.target.value); // Captures text field input
  };

  const handleImpleader = (event) => {
    setImpleader(event.target.value);
  };

  const handleRespondent = (event) => {
    setRespondent(event.target.value);
  };

  const handleIntervenor = (event) => {
    setIntervenor(event.target.value);
  };

  const handleAppellant = (event) => {
    setAppellant(event.target.value);
  };

  const handleUniqueNo = (event) => {
    setUniqueNo(event.target.value); // Captures text field input
  };

  const handleHearingDate = (event) => {
    const dateString = event.target.value;
    const dateObject = new Date(dateString);
    setNextHearingDate(dateObject); // store as Date object
  };
  const handleOsDate = (event) => {
    const dateString = event.target.value;
    const dateObject = new Date(dateString);
    setOsDate(dateObject); // store as Date object
  };
  const handleClosureDate = (event) => {
    const dateString = event.target.value;
    const dateObject = new Date(dateString);
    setClosureDate(dateObject); // store as Date object
  };

  useEffect(() => {
    if (siteId) {
      getUniqueNo({ site_id: siteId })
        .then((response) => {
          setUniqueNo(response.data);
          setUniqueSurveyNo(response.data);
          setSelectedUnique([]);
        })
        .catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          // setLoading(false);
        });
    } else {
      setUniqueNo([]);
    }
  }, []);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const data = {
        site_id: siteId,
        os_number: originalSuite,
        area_under_litigation_acre: Number(litigationAcre) || 0,
        area_under_litigation_gunta: Number(litigationGunta) || 0,
        foundation_role: foundationRole,

        plaintiff: plaintiff || "",
        defendant: defendant || "",
        impleader: impleader || "",
        respondent: respondent || "",
        intervenor: intervenor || "",
        appellant: appellant || "",
        summary: summary || null,
        next_hearing_date: NextHearingDate,
        status: status,
        os_date: osDate,
        closure_date: closureDate,
        court_case_details: courtCaseDetails || null,
        advocate_name: advocateName || null,
        contact_number: contactNumber || null,
        case_requirement: caseRequirement || null,
        cnr_number: cnrNumber || null,
        stage: selectedCourtStage,
        last_date: lastDate || null,
        // ✅ FIX HERE
        unique_survey_no:
          siteType?.toLowerCase() !== "others"
            ? selectedUnique.map((item) => item.unique_survey_no)
            : [],

        case_type_id: selectedCaseType, // ✅ IMPORTANT
        
      };

      const response = await createNewCase(data, token);
      setResponseMessage(response.data?.message || "Case created successfully");
      setIsSuccess(true);
      setModalOpen(true);
      setOpen(false);
      resetSurveyForm();
      if (siteId) {
        const res = await getCourtCases(siteId, token);
        setFilteredRows(Array.isArray(res.data.sites) ? res.data.sites : []);
      }
    } catch (error) {
      const details = error.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(error.response?.data?.detail);
      }
      setIsSuccess(false);
      setModalOpen(true);
      resetSurveyForm();
      setModalSource("createNewCase");
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const resetSurveyForm = () => {
    setOriginalSuite("");
    setSummary("");
    setCourtCaseDetails("");
    setLastDate(null);
    setAdvocateName("");
    setContactNumber("");
    setCaseRequirement("");
    setCnrNumber("");
    setNextHearingDate(null);
    setOsDate("");
    setClosureDate(null);
    setSelectedUnique([]);
    setLitigationAcre("");
    setLitigationGunta("");
    setFoundationRole("");
    setPlaintiff("");
    setDefendant("");
    setImpleader("");
    setRespondent("");
    setIntervenor("");
    setAppellant("");
    setStatus("");
      setSelectedCourtStage(""); // ✅ ADD
  };

  const handleEdit = (os_number) => {
    const site = filteredRows?.find((site) => site.os_number === os_number);
    setOldSuiteNo(os_number); // <-- store original
    setSuiteNo(os_number); // <-- editable field
    setSelectedCaseType(site.case_type_id); // <-- set case type for editing

    if (site) {
      setStateName(site.state || "");
      setCurrentLocation(site.location || "");
      setSite(site.site_name || "");
      setCurrentEditSite(site);
      setOriginalDate(site.os_date || "");
      setSurveyNo(site.unique_survey_no || []);
      // ADD THIS

      setSuiteNo(site.os_number || "");
      setHearingDate(site.next_hearing_date ||null);
      setDate(site.closure_date || null);
      setNewSummary(site.summary || "");
      setStatus(site.status || "");
      setLitigationAcre(site.area_under_litigation_acre || "");
      setLitigationGunta(site.area_under_litigation_gunta || "");
      setFoundationRole(site.role_id || "");
      setFoundationRoleName(site.foundation_role || "");
      setPlaintiff(site.plaintiff || "");
      setDefendant(site.defendant || "");
      setImpleader(site.impleader || "");
      setRespondent(site.respondent || "");
      setIntervenor(site.intervenor || "");
      setAppellant(site.appellant || "");

      // NEW EDIT FIELDS
      setCnrNumber(site.cnr_number || "");
      setLastDate(site.last_date || null);
      setAdvocateName(site.advocate_name || "");
      setCourtCaseDetails(site.court_case_details || "");
      setContactNumber(site.contact_number || "");
      setCaseRequirement(site.case_requirement || "");

      // Court Stage
      setSelectedCourtStage(site.stage || "");
      setIsEditing(true);
      setOpen(true);
      setSelectedUnique(
        Array.isArray(site.unique_survey_no) ? site.unique_survey_no : [],
      );
    } else {
    }
  };

  useEffect(() => {
    if (
      currentEditSite &&
      Array.isArray(currentEditSite.unique_survey_no) &&
      uniqueNo.length > 0
    ) {
      const selectedUniques = uniqueNo.filter((item) =>
        currentEditSite.unique_survey_no.includes(item.unique_survey_no),
      );
      setSelectedUnique(selectedUniques);
    } else {
      setSelectedUnique([]); // fallback to empty array, no null
    }
  }, [currentEditSite, uniqueNo]);

  const handleStatusChange = (event) => {
    setStatus(event.target.value); // Captures text field input
  };
  const handleNewHearingDate = (e) => {
    setHearingDate(e.target.value);
  };

  const handleOriginatDate = (e) => {
    setOriginalDate(e.target.value);
  };

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const handleChangeSummary = (event) => {
    setNewSummary(event.target.value);
  };

  const handleNewCase = async () => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const data = {
        summary: newSummary || null,
        status: status || null,
        os_date: originalDate || null,
        next_hearing_date: hearingDate || null,
        new_os_number: suiteNo,
        closure_date: date || null,
        new_survey_numbers:
          selectedUnique.length > 0
            ? selectedUnique.map((item) => item.unique_survey_no)
            : [],
        area_under_litigation_acre: litigationAcre || null,
        area_under_litigation_gunta: litigationGunta || null,
        // Foundation Role
        foundation_role: foundationRole || null,
        plaintiff: plaintiff || null,
        defendant: defendant || null,
        impleader: impleader || null,
        respondent: respondent || null,
        intervenor: intervenor || null,
        appellant: appellant || null,
        // NEW EDIT FIELDS
        cnr_number: cnrNumber || null,
        last_date: lastDate || null,
        advocate_name: advocateName || null,
        contact_number: contactNumber || null,
        case_requirement: caseRequirement || null,
        // Court Stage
        stage: selectedCourtStage || null,
        court_case_details: courtCaseDetails || null,
      };
      const response = await editCourtCase(oldSuiteNo, data, token);
      setResponseMessage(response.data?.message || "Case updated successfully");
      setIsSuccess(true);
      setModalOpen(true);
      setFilteredRows((prevRows) =>
        prevRows.map((row) =>
          row.os_number === suiteNo
            ? {
                ...row,
                summary: newSummary,
                status: status,
                next_hearing_date: hearingDate,
                closure_date: date,
                unique_survey_no:
                  selectedUnique.length > 0 ? selectedUnique : [],
              }
            : row,
        ),
      );
      setOpen(false);
      if (siteId) {
        const res = await getCourtCases(siteId, token);
        setFilteredRows(Array.isArray(res.data.sites) ? res.data.sites : []);
      }
    } catch (error) {
      const details = error.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(error.response?.data?.detail);
      }
      setIsSuccess(false);
      setModalOpen(true);
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchCourtStatus = async () => {
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: (t) => {
                console.log("Teams SSO token:", t);
                resolve(t);
              },
              failureCallback: (err) => {
                console.error("Teams SSO error:", err);
                reject(err);
              },
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getCourtStatus(token);
        setCourtCase(response.data);
        console.log(response);
      } catch (error) {}
    };
    fetchCourtStatus();
  }, []);

  return (
    <>
      <div>
        <TopNav />
      </div>
      <div className="px-[35px] py-2 font-bold text-2xl">
        <Link to="/sitecreation">Site Creation</Link> {">"} {state} {">"}{" "}
        {locationName} {`>`} {siteName} {">"} Court Case{" "}
      </div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Original Suite No"
            placeholder="None"
            responseData={osNo}
            labelKey="os_number"
            valueKey="os_number"
            onChange={(e) => setOsNoId(e.target.value)}
            value={osNoId}
          />
        </div>

        <div className="w-full sm:w-auto flex-shrink-0">
          <Autocomplete
            multiple
            id="multi-select-unique-no"
            options={uniqueSurveyNo} // Array of options
            getOptionLabel={(option) => option.unique_survey_no} // Label shown in the dropdown
            value={selectedUniqueId} // This should be an array of selected items
            onChange={(event, newValue) => {
              setSelectedUniqueId(newValue); // Update state with the new value
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Unique Survey No"
                placeholder="Select"
                size="small"
              />
            )}
            sx={{ width: 200 }}
          />
        </div>

        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setOsNoId("");
              setSelectedUniqueId([]);
            }}
            sx={{
              backgroundColor: "#1381B5",
              "&:hover": { backgroundColor: "#0f6c99" },
              width: "95px",
              height: "40px",
              fontSize: "10px",
              whiteSpace: "nowrap", // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>
        <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
          <NewSiteButton Name="Add Court Case" handleOpen={handleOpen} />
        </div>
      </div>
      <SiteModal
        open={open}
        handleClose={() => setOpen(false)}
        title={isEditing ? "Edit Court Case" : "New Court Case"}
        handleSubmit={isEditing ? handleNewCase : handleSubmit}
        formContent={
          isEditing ? (
            <EditCourtCase
              isEditing={isEditing}
              stateName={stateName}
              locationName={currentLocation}
              siteName={site}
              OSUiteNo={suiteNo}
              responseDataStatus={courtCase}
              currentStatus={status}
              onChangeStatus={handleStatusChange}
              courtStatus="status"
              selectedCourtStatus="status"
              NextHearingDate={hearingDate}
              OriginalSuiteDate={originalDate}
              onChangeOriginalSuiteDate={handleOriginatDate}
              ClosureDate={date}
              setSelectedUnique={setSelectedUnique}
              responseDataUniqueNo={uniqueNo}
              uniqueNoName="unique_survey_no"
              selectedUniqueId="unique_survey_no"
              uniqueNoId={selectedUnique}
              onChangeNextHearingDate={handleNewHearingDate}
              onChangeClosureDate={handleDate}
              summary={newSummary}
              onChangeSummary={handleChangeSummary}
              areaUnderLitigationAcre={litigationAcre}
              onChangeLitigationAcre={handleLitigationAcre}
              areaUnderLitigationGunta={litigationGunta}
              onChangeLitigationGunta={handleLitigationGunta}
              foundationRoleId={foundationRole}
              onChangeFoundationRole={handleFoundationRole}
              foundationRoleName={foundationRoleName}
              siteType={siteType}
              caseTypes={caseTypes}
              selectedCaseType={selectedCaseType}
              setSelectedCaseType={setSelectedCaseType}
              plaintiff={plaintiff}
              defendant={defendant}
              impleader={impleader}
              respondent={respondent}
              intervenor={intervenor}
              appellant={appellant}
              onChangePlaintiff={handlePlaintiff}
              onChangeDefendant={handleDefendant}
              onChangeImpleader={handleImpleader}
              onChangeRespondent={handleRespondent}
              onChangeIntervenor={handleIntervenor}
              onChangeAppellant={handleAppellant}
              // NEW EDIT FIELDS
              cnrNumber={cnrNumber}
              onChangeCnrNumber={handleCnrNumber}
              LastDate={lastDate}
              onChangeLastDate={handleLastDate}
              advocateName={advocateName}
              onChangeAdvocateName={handleAdvocateName}
              contactNumber={contactNumber}
              onChangeContactNumber={handleContactNumber}
              caseRequirement={caseRequirement}
              onChangeCaseRequirement={handleCaseRequirement}
              // COURT STAGE
              courtStages={courtStages}
              selectedCourtStage={selectedCourtStage}
              setSelectedCourtStage={setSelectedCourtStage}
              courtCaseDetails={courtCaseDetails}
onChangeCourtCaseDetails={handleCourtCaseDetails}
              onChangeOriginalSuite={(e) => setSuiteNo(e.target.value)}
            />
          ) : (
            <CourtForm
              responseDataState={responseData}
              stateName="state"
              selectedState="state"
              selectedLocation="location_name"
              stateId={state}
              responseDataLocation={responseData}
              locationName="location_name"
              locationId={locationName}
              responseData={responseData}
              siteName="name"
              selectedSiteID="site_id"
              siteId={siteId}
              onChangeSummary={handleSummary}
              onChangeOriginalSuite={handleOriginalSuite}
              onChangeNextHearingDate={handleHearingDate}
              onChangeClosureDate={handleClosureDate}
              onChangeOriginalSuiteDate={handleOsDate}
              onChangeLitigationAcre={handleLitigationAcre}
              onChangeLitigationGunta={handleLitigationGunta}
              onChangeFoundationRole={handleFoundationRole}
              foundationRoleName={foundationRoleName}
              onChangeDefendant={handleDefendant}
              onChangePlaintiff={handlePlaintiff}
              onChangeImpleader={handleImpleader}
              onChangeRespondent={handleRespondent}
              onChangeIntervenor={handleIntervenor}
              onChangeAppellant={handleAppellant}
              foundationRoleId={foundationRole}
              setSelectedUnique={setSelectedUnique}
              responseDataUniqueNo={uniqueNo}
              uniqueNoName="unique_survey_no"
              selectedUniqueId="unique_survey_no"
              uniqueNoId={selectedUnique}
              responseDataStatus={courtCase}
              courtStatus="status"
              selectedCourtStatus="status"
              currentStatus={status}
              onChangeStatus={handleStatusChange}
              caseTypes={caseTypes}
              selectedCaseType={selectedCaseType}
              setSelectedCaseType={setSelectedCaseType}
              siteType={siteType}
              onChangeCourtCaseDetails={handleCourtCaseDetails}
              onChangeLastDate={handleLastDate}
              LastDate={lastDate}
              onChangeAdvocateName={handleAdvocateName}
              onChangeContactNumber={handleContactNumber}
              onChangeCaseRequirement={handleCaseRequirement}
              onChangeCnrNumber={handleCnrNumber}
              courtStages={courtStages}
              selectedCourtStage={selectedCourtStage}
              setSelectedCourtStage={setSelectedCourtStage}
            />
          )
        }
      />

      <EnhancedTable
        rows={rowsFiltered}
        header={tableHeaders}
        verticalAlign="top"
      />
      {/* requirement want to disbale survey no and Area In Acre so using differnt table  */}
      {/* <div className="py-2 px-[35px]">
        <EnhancedTable
          rows={rowsFiltered}
          header={content.courtLitigation} // or whichever headers you're using
          verticalAlign="top"
        />
      </div> */}
      {loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);
          if (!isSuccess && modalSource === "createNewCase") {
            window.location.reload(); // refresh the page
          }
        }}
        message={responseMessage}
        isSuccess={isSuccess}
      />
      <CourtHistoryModal
        open={openHistoryModal}
        onClose={() => setOpenHistoryModal(false)}
        os_number={selectedOsNumber}
      />
    </>
  );
};

export default CourtCases;
